import { IdentityDocumentFullModel } from './identity-document.model';
import { ActivityModelFull } from './activity-model';
import { CohabitantModelFull } from './cohabitant-model';
import { SellerModelFull } from './seller-model';

export class GetReadyModelFull {
  seller?: SellerModelFull;
  solicitation_id: string;
  prospect_id: string;
  identity_documents: IdentityDocumentFullModel[];
  solicitation_type: string;
  phone: string;
  email: string;
  confirmEmail: string;
  start_date_activity: string;
  principal_activity: ActivityModelFull | any;
  marital_status: string;
  cohabitant: CohabitantModelFull;
  rut: string;
  monthly_income: any;

  constructor() {
    this.solicitation_id = '';
    this.prospect_id = '';
    this.identity_documents = [];
    this.identity_documents.push(new IdentityDocumentFullModel());
    this.solicitation_type = 'aperturadecuentas';
    this.phone = '';
    this.email = '';
    this.confirmEmail = '';
    this.marital_status = '';
    this.start_date_activity = '';
    this.principal_activity = new ActivityModelFull();
    this.cohabitant = new CohabitantModelFull();
    this.rut = '';
    this.monthly_income = null;
  }
}
